// src/store/settingsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "app_show_suggestions";

const loadBool = (fallback = true) => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === null) return fallback;
    return v === "true" || v === "1";
  } catch {
    return fallback;
  }
};

const saveBool = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(Boolean(value)));
  } catch {}
};

const initialState = {
  showSuggestions: loadBool(true), // ✅ الافتراضي: نعم
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setShowSuggestions(state, action) {
      state.showSuggestions = Boolean(action.payload);
      saveBool(state.showSuggestions);
    },
    toggleShowSuggestions(state) {
      state.showSuggestions = !state.showSuggestions;
      saveBool(state.showSuggestions);
    },
  },
});

export const { setShowSuggestions, toggleShowSuggestions } =
  settingsSlice.actions;

export const selectShowSuggestions = (state) =>
  state.settings?.showSuggestions ?? true;

export default settingsSlice.reducer;
export { STORAGE_KEY };
